$(document).ready(function() {
	$('.view-reviews').on('click', function() {
		var aTag = $('#initialized-id-65069e60-a1d5-11ea-b5cf-9f36a4c0a89d');
		$('html,body').animate({scrollTop: aTag.offset().top-100},'slow');
	});


    $('.scrollon').on('click', function(e) {
    	e.preventDefault();
		var aHref = $(this);
		$('html,body').animate({scrollTop: aHref.offset().top},'slow'); 
	});


	$('.o-support-tools .btn-mobile-search').click(function() {
		$('.main-header-wrapper .search-mobile').addClass('active');
		$('.btn-close-search').show();
		var headerHeight = $('.main-header-wrapper').outerHeight();
	    var announcementBarHeight = $('.pxs-announcement-bar').outerHeight();
	    var totalHeight = headerHeight + announcementBarHeight;
	    $('body').css('padding-top', totalHeight + 'px');
	});

	$('.gl-d-searchbox-mb').click(function() {
		$('.btn-close-search').show();
	});

	/*$('.btn-close-search').click(function() {
		$('.main-header-wrapper .search-mobile').removeClass('active');
	});*/

	$('.btn-close-search').click(function() {
		$('.btn-close-search').hide();
		$(".gl-d-searchbox-mb").val('');
		$(".gl-row").children().remove();
	});
});